import * as yup from 'yup';

import {
  emailYupValidation,
  fieldStateYupValidation,
} from '@/shared/utils/validationSchema';

export const preagendamientoFormSchema = yup.object({
  direccion: yup
    .string()
    .required('El campo dirección es requerido')
    .max(250, 'El campo dirección no debe exceder los 250 caracteres'),
  persona_referencia_nombre: yup
    .string()
    .required('El campo persona referencia nombre es requerido')
    .max(
      200,
      'El campo persona referencia nombre no debe exceder los 200 caracteres'
    ),

  persona_referencia_parentesco: yup
    .string()
    .required('El campo persona referencia parentesco es requerido')
    .max(
      200,
      'El campo persona referencia parentesco no debe exceder los 200 caracteres'
    ),

  celular: yup
    .string()
    .required('El campo celular es requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  // .test(
  //   'no-repeat',
  //   'El número de teléfono no puede ser igual al número de celular',
  //   function (value) {
  //     const anotherCelulars = [
  //       this.parent.celular_2,
  //       this.parent.persona_referencia_celular,
  //     ];
  //     return !anotherCelulars.includes(value);
  //   }
  // ),
  celular_2: yup
    .string()
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),

  // persona_referencia_celular: yup.string().optional(),
  persona_referencia_celular: yup
    .string()
    .required('El campo persona referencia celular es requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
    // .test(
    //   'no-repeat',
    //   'El número de teléfono no puede ser igual al número de celular',
    //   function (value) {
    //     const anotherCelulars = [this.parent.celular, this.parent.celular_2];
    //     return !anotherCelulars.includes(value);
    //   }
    // ),
  //email: emailYupValidation,

  /* fecha_instalacion: yup
    .string()
    .required('El campo fecha instalacion es requerido')
    .max(200, 'El campo fecha instalacion no debe exceder los 200 caracteres'),
  hora_instalacion: yup
    .string()
    .required('El campo hora instalacion es requerido')
    .max(200, 'El campo hora instalacion no debe exceder los 200 caracteres'), */
  coordenadas: yup
    .string()
    .required('El campo coordenadas es requerido')
    .max(200, 'El campo coordenadas no debe exceder los 200 caracteres'),
  distancia: yup
    .string()
    .required('El campo distancia es requerido')
    .max(200, 'El campo distancia no debe exceder los 200 caracteres'),

  estado: fieldStateYupValidation,

  // estado llamada pyl
  estado_llamada: yup
    .string()
    .required('El campo estado llamada es requerido')
    .max(200, 'El campo estado llamada no debe exceder los 200 caracteres'),
  observacion_llamada: yup
    .string()
    .required('El campo observacion llamada es requerido')
    .max(
      200,
      'El campo observacion llamada no debe exceder los 200 caracteres'
    ),

  preventa: yup
    .string()
    .required('El campo preventa es requerido')
    .max(200, 'El campo preventa no debe exceder los 200 caracteres'),
  // nap: yup
  //   .string()
  //   .required('El campo nap es requerido')
  //   .max(200, 'El campo nap no debe exceder los 200 caracteres'),
  flota: yup
    .string()
    .required('El campo flota es requerido')
    .max(200, 'El campo flota no debe exceder los 200 caracteres'),

  pais: yup
    .string()
    .required('El campo pais es requerido')
    .max(200, 'El campo pais no debe exceder los 200 caracteres'),
  provincia: yup
    .string()
    .required('El campo provincia es requerido')
    .max(200, 'El campo provincia no debe exceder los 200 caracteres'),
  ciudad: yup
    .string()
    .required('El campo ciudad es requerido')
    .max(200, 'El campo ciudad no debe exceder los 200 caracteres'),
  zona: yup
    .string()
    .required('El campo zona es requerido')
    .max(200, 'El campo zona no debe exceder los 200 caracteres'),
  sector: yup
    .string()
    .required('El campo sector es requerido')
    .max(200, 'El campo sector no debe exceder los 200 caracteres'),

  isRejecting: yup.boolean().optional().nullable(),
  motivo_rechazo: yup
    .string()
    .nullable()
    .when('isRejecting', {
      is: true,
      then: schema =>
        schema
          .required('El campo motivo rechazo es requerido')
          .max(
            200,
            'El campo motivo rechazo no debe exceder los 200 caracteres'
          ),
    }),
});

export const preagendamientoSolicitudUpdFormSchema = yup.object({
  motivo_rechazo: yup
    .string()
    .required('El campo motivo rechazo es requerido')
    .max(200, 'El campo motivo rechazo no debe exceder los 200 caracteres'),
  estado_preagendamiento: yup
    .string()
    .required('El campo estado preagendamiento es requerido')
    .max(
      200,
      'El campo estado preagendamiento no debe exceder los 200 caracteres'
    ),
});
